import axios from "axios";
import { API_BASE_URL } from "../environment";

export const createNewProduct = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/common?table=products`, data);
  return res.data;
};
export const getAllProduct = async (data) => {
  const prod = JSON.parse(sessionStorage.getItem("info"));
  const res = await axios.get(
    `${API_BASE_URL}/product?user_id=${prod.id}&user_type=${prod.type}&start_date=${data.start_date}&end_date=${data.end_date}`
  );
  return res.data;
};

export const getAllProductByName = async (data) => {
  const prod = JSON.parse(sessionStorage.getItem("info"));
  const res = await axios.get(
    `${API_BASE_URL}/product/product-by-name?user_id=${prod.id}&user_type=${prod.type}&product_name=${data.product_name}&start_date=${data.start_date}&end_date=${data.end_date}`
  );
  return res.data;
};

export const getProductById = async (id) => {
  const res = await axios.get(`${API_BASE_URL}/plans/${id}`);
  return res.data;
};
